import {
  buildDeserializer,
  buildSerializer,
  SerializeMap,
} from "lib/serializerUtils";

const allocationsMap: SerializeMap<BuyerSplitAllocation> = {
  businessId: "business_id",
  amount: "amount",
};

export const buyerSplitSerializerMap: SerializeMap<BuyerSplit> = {
  id: "id",
  livestockSaleId: "livestock_sale_id",
  deploymentId: "deployment_id",
  includeFees: "include_fees",
  isActive: "is_active",
  isDefault: "is_default",
  primaryBusinessId: "primary_business_id",
  saleLotId: "sale_lot_id",
  type: "type",
  splits: allocationsMap,
};

export const serializeBuyerSplit = buildSerializer<BuyerSplit>(
  buyerSplitSerializerMap,
  "buyerSplit",
  { splits: "splits" },
);

export const deserializeBuyerSplit = buildDeserializer<BuyerSplit>(
  buyerSplitSerializerMap,
  "buyerSplit",
  { splits: "splits" },
);
